import { EmbeddedContext, type EmbeddedContextValue } from '@src/providers/EmbeddedContextProvider';
import { useContext } from 'react';

export function useEmbeddedContext(): EmbeddedContextValue {
  return useContext(EmbeddedContext);
}
